import React, { useEffect } from 'react'
import { isEmpty, trim, compose, defaultTo, prop, pathOr } from 'ramda'
import { useForm, useFetch } from '../../../../hooks'
import Button from '../../../../components/inputs/Button'
import Buttons from '../../../../modules/Buttons'
import { FormHeader, FormBody, Form } from '../../../../modules/Form/styled'
import FromInput from '../../../../components/inputs/FromInput'
import { toast } from 'react-toastify'

const FormEditZone = ({ zoneid, zonename, refetchZoneCard, onClickCancel, onClickClose, translation }) => {
    const { doFetch } = useFetch({
        url: '/rpc/change_zone_config',
        method: 'POST',
        state: false
    })

    const validate = values => {
        const isEmptyZoneName = compose(isEmpty, trim, defaultTo(''), prop('zone_name'))
        if (isEmptyZoneName(values)) {
            return {
                zone_name: pathOr('', ['hint'], translation)
            }
        }
        return {}
    }

    const updateZone = async values => {
        const { zone_name } = values;
        const response = await doFetch({
            data: {
                zoneid,
                zone_name
            }
        })
        const isError = pathOr(false, ['error'], response);
        const message = pathOr(null, ['msg'], response);
        if (isError) {
            message && toast.error(message);
        } else {
            message && toast.success(message);
            onClickClose();
            refetchZoneCard && refetchZoneCard();
        }
    }

    const { values, errors, setValue, handleChange, handleSubmit } = useForm({
        callback: updateZone,
        validate: validate
    })

    useEffect(() => {
        if(values.zone_name !== zonename) {
            setValue({
                zone_name: zonename
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [zonename])

    return (
        <Form onSubmit={handleSubmit} noValidate autoComplete="off">
            <FormHeader>
                {pathOr("", ['title'], translation)}
            </FormHeader>
            <FormBody>
                <FromInput
                    type='text'
                    placeholder={pathOr("", ["placeholder"], translation)}
                    name='zone_name'
                    onChange={handleChange}
                    value={values.zone_name}
                    error={errors.zone_name}
                    fullWidth
                    margin="0 0 10px 0"
                />
                <Buttons>
                    <Button
                        type='submit'
                        fullWidth
                        green
                    >
                        {pathOr("", ["buttons", "save"], translation)}
                    </Button>
                    <Button
                        type='button'
                        fullWidth
                        onClick={onClickCancel}
                    >
                        {pathOr("", ["buttons", "cancel"], translation)}
                    </Button>
                </Buttons>
            </FormBody>
        </Form>
    )
}

export default FormEditZone
